import { useAuthStore } from '@/features/auth/useAuthStore.js'
import { isSuperAdmin } from '@/features/superAdmin/useIsSuperAdmin.js'

export async function clubLandingHomeGuard(to, from, next) {
  const authStore = useAuthStore()

  if (!authStore.isLoggedIn) {
    next()
    return
  }

  await authStore.getMyDetails()

  if (isSuperAdmin(authStore.myDetails)) {
    next({ path: '/super-admin', replace: true })
    return
  }

  const activeClubId = Array.isArray(to.query?.activeClubId)
    ? to.query.activeClubId[0]
    : to.query?.activeClubId

  next({
    path: '/landing',
    query: activeClubId ? { activeClubId } : {},
    replace: true,
  })
}
